import { __assign } from "tslib";
import { createHttpTestKit } from '../http/test-kit';
import { createTicketsApi, PRESENCE_TTL, } from './';
import { createFakeGetResponder, createFakePutResponder, createFakePostResponder, createFakeDeleteResponder } from '../test-utils';
import { createMultiLingualCustomFieldsApiTestKitHandler } from '../custom-fields';
export var createTicketsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createTicketsApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetTicket: function (id) {
            return createFakeGetResponder(fakeHttp, '/tickets/' + id);
        },
        whenGetExtendedTicket: function (id) {
            return createFakeGetResponder(fakeHttp, '/tickets/' + id + '/admin');
        },
        whenAddTicketCallNote: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + dto.ticketId + "/calls/" + dto.callId + "/notes")({});
        },
        whenUpdateTicketCallNote: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/" + dto.ticketId + "/calls/" + dto.callId + "/notes/" + dto.noteId)({});
        },
        whenDeleteTicketCallNote: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/tickets/" + dto.ticketId + "/calls/" + dto.callId + "/notes/" + dto.noteId);
        },
        whenRequestCallback: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/callbackRequests')(dto);
        },
        whenCancelCallback: function (dto) {
            var reqUrl = "/tickets/" + dto.ticketId + "/calls/" + dto.callId + "/cancelCallback";
            return createFakePostResponder(fakeHttp, reqUrl)(dto);
        },
        whenTransferCallToNumber: function (dto) {
            var reqUrl = "/tickets/" + dto.ticketId + "/calls/" + dto.callId + "/transferToNumber";
            return createFakePostResponder(fakeHttp, reqUrl)(dto);
        },
        whenGetTransferHistory: function (dto) {
            var reqUrl = "/tickets/" + dto.ticketId + "/calls/" + dto.callId + "/cancelCallback";
            return createFakePostResponder(fakeHttp, reqUrl)(dto);
        },
        whenGetTicketByNumber: function (dto) {
            return createFakeGetResponder(fakeHttp, "/tickets/byNumber/" + dto.ticketNumber + "/admin");
        },
        whenSyncCall: function (dto) {
            var reqUrl = "/tickets/" + dto.ticketId + "/calls/" + dto.callId + "/sync";
            return createFakePostResponder(fakeHttp, reqUrl)(dto);
        },
        whenTransferTicket: function (dto, fail) {
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, "/tickets/" + dto.ticketId + "/transfer", fail)({ targetUserId: dto.targetUserId });
        },
        whenSearchAdmin: function (dto) {
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, '/tickets/search/admin')(dto);
        },
        whenSearchAdminIncludeConversation: function (dto) {
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, '/tickets/search/admin/includeConversation')(dto);
        },
        whenReplyTickets: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/agentReplies')(dto);
        },
        whenReplyTicketsNew: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/agentReplies/new')(dto);
        },
        whenReplyTicket: function (dto) {
            var ticketId = dto.id || '';
            return createFakePostResponder(fakeHttp, "/tickets/" + ticketId + "/agentReply")(dto);
        },
        whenRelationsTickets: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/agentReplies')(dto);
        },
        whenSetTicketsStatus: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/setStatus')(dto);
        },
        whenSetTicketStatus: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/" + dto.id + "/status")(dto);
        },
        whenAssignTickets: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/assign')(dto);
        },
        whenSetTicketsPriority: function (dto, fail) {
            return createFakePostResponder(fakeHttp, '/tickets/setPriority', fail)(dto);
        },
        whenMarkTicketsAsSpam: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/markSpam')(dto);
        },
        whenMarkTicketsAsHam: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/markHam')(dto);
        },
        whenDeleteTickets: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/delete')(dto);
        },
        whenUpdateTicketsLabels: function (dto) {
            return createFakePutResponder(fakeHttp, '/tickets/labels')(dto);
        },
        whenGetSavedFilter: function (dto) {
            var id = dto.id;
            return createFakeGetResponder(fakeHttp, "/savedFilters/" + id);
        },
        whenGetSavedFilters: function (dto) {
            var locale = dto.locale, context = dto.context;
            var maybeContext = context ? "&context=" + context : '';
            return createFakeGetResponder(fakeHttp, "/savedFilters?locale=" + locale + maybeContext);
        },
        whenGetSavedFiltersNew: function (dto) {
            return createFakePostResponder(fakeHttp, '/savedFilters/new')(dto);
        },
        whenGetSavedFiltersPerLocale: function (dto) {
            var locales = dto.locales, context = dto.context;
            return createFakeGetResponder(fakeHttp, "/savedFilters/perLocale?locales=" + locales + "&context=" + context);
        },
        whenUpdateSavedFilter: function (dto) {
            var id = dto.id;
            return createFakePutResponder(fakeHttp, "/savedFilters/" + id)(dto);
        },
        whenUpdateSavedFilterNew: function (dto) {
            var id = dto.id;
            return createFakePutResponder(fakeHttp, "/savedFilters/" + id + "/new")(dto);
        },
        whenDeleteSavedFilter: function (dto) {
            var id = dto.id;
            return createFakeDeleteResponder(fakeHttp, "/savedFilters/" + id);
        },
        whenAddSavedFilter: function (dto) {
            return createFakePostResponder(fakeHttp, "/savedFilters")(dto);
        },
        whenRenameSavedFilter: function (dto) {
            var id = dto.id;
            return createFakePutResponder(fakeHttp, "/savedFilters/" + id + "/rename")(dto);
        },
        whenGetPresenceInfoList: function (dto) {
            var dtoWithTtl = dto !== '*' ? __assign(__assign({}, dto), { maxAge: PRESENCE_TTL }) : dto;
            return createFakePostResponder(fakeHttp, "/tickets/presence")(dtoWithTtl);
        },
        whenAddTicket: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/outbound")(dto);
        },
        whenAddTicketOnBehalf: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/onBehalf")(dto);
        },
        whenGetCustomFields: function () {
            return createFakeGetResponder(fakeHttp, "/fields");
        },
        whenGetFiltersTicketsCount: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/filtersCounts")(dto);
        },
        whenGetFiltersTicketsCountNew: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/filtersCounts/new")(dto);
        },
        whenGetTicketTimeline: function (dto) {
            return createFakeGetResponder(fakeHttp, "/tickets/" + dto.ticketId + "/timeline");
        },
        whenAddTimelineEvent: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + dto.ticketId + "/timeline")({ customText: dto.customText });
        },
        whenUpdateTicketCustomFields: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/" + dto.id + "/fields")(__assign(__assign({}, dto), { id: undefined }));
        },
        whenApplyMacro: function (dto, fail) {
            var macroId = dto.macroId, ticketId = dto.ticketId;
            return createFakePostResponder(fakeHttp, "/tickets/" + ticketId + "/macros/" + macroId + "/execute", fail)({ macroId: macroId });
        },
        whenGetSavedReplies: function (dto) {
            return createFakePostResponder(fakeHttp, "/savedReplies/search")(dto);
        },
        whenGetSavedReply: function (dto) {
            return createFakeGetResponder(fakeHttp, "/savedReplies/" + dto.id + "/admin/?locale=" + dto.locale);
        },
        whenCustomFields: createMultiLingualCustomFieldsApiTestKitHandler('/tickets', fakeHttp),
        whenDeleteCallRecording: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/tickets/" + dto.ticketId + "/calls/" + dto.callId + "/deleteRecording");
        },
        whenUpdateReplyContent: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/" + dto.id + "/replies/" + dto.replyId)(dto);
        },
        whenSetLocale: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/" + dto.ticketId + "/locale")({ newLocale: dto.newLocale });
        },
        whenFollow: function (id) { return createFakePostResponder(fakeHttp, "/tickets/" + id + "/follow")({}); },
        whenUnfollow: function (id) { return createFakeDeleteResponder(fakeHttp, "/tickets/" + id + "/follow"); },
        whenUpdateTicketContent: function (dto) {
            var id = dto.id, content = dto.content, subject = dto.subject;
            return createFakePutResponder(fakeHttp, "/tickets/" + id)({ content: content, subject: subject });
        },
        whenIsTicketFollowed: function (dto) { return createFakeGetResponder(fakeHttp, "/tickets/" + dto.id + "/follow"); },
        whenRelatedArticles: function (ticketId) { return createFakeGetResponder(fakeHttp, "/tickets/" + ticketId + "/relations/admin"); },
        whenRemoveRelations: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + dto.id + "/relations/remove")({ relatedArticleIds: dto.relatedArticleIds });
        },
        whenSession: {
            whenStartForAgent: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/" + dto.id + "/startHandling")(dto); },
            whenEndForAgent: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/" + dto.id + "/endHandling/new")(dto); },
            whenEndForAll: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/" + dto.id + "/endAllHandling/new")(dto); },
            whenBulkEndForAgent: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/endHandling/bulk")(dto); },
            whenBulkEndForAll: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/endAllHandling/bulk")(dto); },
        },
        whenReportTicketPresenceStatus: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/" + dto.id + "/presence")(dto); },
        whenUpdateTicketCompany: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/company")({ ids: [dto.id], companyId: dto.companyId });
        },
        whenUpdateTicketAndAgentCompany: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/" + dto.id)({ companyId: dto.companyId });
        },
        whenSnoozeTicket: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/snooze")(dto); },
        whenUnsnoozeTicket: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/unSnooze")(dto); },
        whenMergeTickets: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/merge")(dto);
        },
        whenAddAgentInternalNote: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/" + (dto.id || '') + "/agentInternalNote")(dto); },
        whenAddAgentInternalNotes: function (dto) { return createFakePostResponder(fakeHttp, '/tickets/agentInternalNotes')(dto); },
        whenGetReplyRawEmail: function (dto) { return createFakeGetResponder(fakeHttp, "/tickets/" + dto.ticketId + "/replies/" + dto.replyId + "/rawEmail"); },
        whenUpdateTicketBrand: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/" + dto.ticketId + "/brand")({ brandId: dto.brandId });
        },
        whenGetTicketAutoRoutingAssignments: function (id) {
            return createFakeGetResponder(fakeHttp, "/tickets/" + id + "/autoRouting/assignments");
        },
        whenTransferChat: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + dto.ticketId + "/chatTransfer")(dto);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map